import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { EventData } from '~admin/model/event-data';
import { mapEventData } from '~admin/model/event-data.mapper';
import { EventProfileUpdateRequest } from '~client/model/admin/event-profile-update-request';
import { EventResponse } from '~client/model/admin/event-response';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';

export type UpdateEventProfileTask = OneArgTask<EventProfileUpdateRequest, EventData>;

/**
 * Updates details about an event
 * @param request
 */
export const performUpdateEventProfile = (
  request: EventProfileUpdateRequest,
): Observable<EventResponse> => apiClient.eventAdminController.updateEventProfile$(request);

export const updateEventProfileTaskFactory = (): UpdateEventProfileTask =>
  rxTask<EventProfileUpdateRequest, EventData>((request: EventProfileUpdateRequest) =>
    performUpdateEventProfile(request).pipe(map(mapEventData)),
  );



// WEBPACK FOOTER //
// ./interactor/event/perform-update-event-profile.ts